import { render, staticRenderFns } from "./Splide.vue?vue&type=template&id=1cbd4261&"
import script from "./Splide.vue?vue&type=script&lang=js&"
export * from "./Splide.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports